import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getInbound,
  getIdInbound,
  createInbound,
  updateInbound,
  deleteInbound,
  getVehicle,
  getIdVehicle,
  createVehicle,
  updateVehicle,
  deleteVehicle,
  uploadFile,
  createVehicleUpload,
  geListInspection,
  updateVehicleConfirm,
  updateInboundSetStatus,
  updateVehicleComplate,
  getIdVehicleSeperator,
  updateInboundConfirm,
  updateInboundCancel,
  getFilter,
  createFilter,
  deleteFilter,
  uploadFileRCI,
  uploadFilePDIIN,
  uploadFileTSA,
  uploadFilePDIOUT,
  deleteVehicleWorkFlow,
  getFileRCI,
  getFile,
  getFileBlob,
  createPrint,
  getPrint,
  updateInboundAmend,
  updateVehicleTSA,
  deleteVehicleWorkFlowTSA,
  updateVehicleMovementWorkflow,
  deleteVehicleWorkFlowMovement,
  deleteVehicleWorkFlowRCI,
  updateVehicleRCI,
  updateVehiclePDI,
  deleteVehicleWorkFlowPDI,
  updateVehicleStocktake,
  deleteVehicleWorkFlowStocktake,
  deleteVehicleWorkFlowPicking,
  updateVehiclePicking,
  deleteVehicleWorkFlowHandover,
  updateVehicleBTS,
  updateVehicleHandover,
  deleteVehicleWorkFlowBTS,
  updateVehicleMaintenance,
  updateVehicleInspection,
  updateVehicleRepdiin,
  updateVehicleRepdiout,
  updateVehicleInfoUpdate,
  deleteVehicleWorkFlowMaintenance,
  deleteVehicleWorkFlowInspection,
  deleteVehicleWorkFlowRePdiin,
  deleteVehicleWorkFlowInfoUpdate,
  deleteVehicleWorkFlowRePdiout,
  updateVehicleConfirmMovement,
  updateVehicleCompleteMovement,
  updateVehicleConfirmStocktake,
  updateVehicleCompleteStocktake,
  getIdVehicleSeperatorMaintenance,
  getVehicleMaintenace,
  updateVehicleCompleteMaintenance,
  updateVehicleConfirmMaintenance,
  updateVehicleConfirmInspection,
  updateVehicleConfirmREPDIIN,
  updateVehicleConfirmREPDIOUT,
  updateVehicleCompleteREPDIIN,
  getIdVehicleSeperatorStocktake,
  getVehicleStocktake,
  updateVehicleConfirmBTS,
  getVehicleInfoUpdate,
  getIdVehicleSeperatorInfoUpdate,
  updateVehicleConfirmInfoUpdate,
  updateVehicleCompleteInfoUpdate,
  getVehicleOutbound,
  getVehicleMovement,
  getVehicleOutboundWorkflow,
  getVehicleInboundWorkflow,
  getGenerateExcelBlob,
  getMaintenanceActivityDetail
} from "./inboundAPI";

const initialState = {
  data: [],
  dataId: null,
  dataInspetion: null,
  dataVehicle: [],
  dataVehiclePrint: [],
  dataIdVehicle: null,
  dataIdVehicleFind: null,
  dataFilter: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,

  permissionsRci: [],
  permissionsPdiin: [],
  permissionsPdiout: [],
  permissionsStorage: [],
  permissionsList: [],
};

export const fetchInbound = createAsyncThunk(
  "Inbound/fetchInbound",
  async (payload) => {
    const response = await getInbound(payload);
    return response;
  }
);

export const addInbound = createAsyncThunk(
  "Inbound/addInbound",
  async (payload) => {
    const response = await createInbound(payload);
    return response;
  }
);

export const editInbound = createAsyncThunk(
  "Inbound/editInbound",
  async (payload) => {
    const response = await updateInbound(payload);
    return response;
  }
);

export const editInboundSetstatus = createAsyncThunk(
  "Inbound/editInboundSetstatus",
  async (payload) => {
    const response = await updateInboundSetStatus(payload);
    return response;
  }
);

export const editInboundConfirm = createAsyncThunk(
  "Inbound/editInboundConfirm",
  async (payload) => {
    const response = await updateInboundConfirm(payload);
    return response;
  }
);
export const editInboundAmend = createAsyncThunk(
  "Inbound/editInboundAmend",
  async (payload) => {
    const response = await updateInboundAmend(payload);
    return response;
  }
);

export const editInboundCancel = createAsyncThunk(
  "Inbound/editInboundCancel",
  async (payload) => {
    const response = await updateInboundCancel(payload);
    return response;
  }
);

export const fetchIdInbound = createAsyncThunk(
  "Inbound/fetchIdInbound",
  async (id) => {
    const response = await getIdInbound(id);
    return response;
  }
);

export const removeInbound = createAsyncThunk(
  "Inbound/removeInbound",
  async (payload) => {
    const response = await deleteInbound(payload);
    return response;
  }
);

export const addUploadFile = createAsyncThunk(
  "Inbound/addUploadFile",
  async ({ id, file }) => {
    const response = await uploadFile(id, file);
    return response;
  }
);
export const addUploadFileRCI = createAsyncThunk(
  "Inbound/addUploadFileRCI",
  async ({ id, file }) => {
    const response = await uploadFileRCI(id, file);
    return response;
  }
);
export const addUploadFilePDIIN = createAsyncThunk(
  "Inbound/addUploadFilePDIIN",
  async ({ id, file }) => {
    const response = await uploadFilePDIIN(id, file);
    return response;
  }
);
export const addUploadFilePDIOUT = createAsyncThunk(
  "Inbound/addUploadFilePDIOUT",
  async ({ id, file }) => {
    const response = await uploadFilePDIOUT(id, file);
    return response;
  }
);
export const addUploadFileTSA = createAsyncThunk(
  "Inbound/addUploadFileTSA",
  async ({ id, file }) => {
    const response = await uploadFileTSA(id, file);
    return response;
  }
);

// Vehicle
export const fetchVehicle = createAsyncThunk(
  "Vehicle/fetchVehicle",
  async (payload) => {
    const response = await getVehicle(payload);
    return response;
  }
);
export const fetchVehicleInboundWorkflow = createAsyncThunk(
  "Vehicle/fetchVehicleInboundWorkflow",
  async (payload) => {
    const response = await getVehicleInboundWorkflow(payload);
    return response;
  }
);
export const fetchVehicleOutboundWorkflow = createAsyncThunk(
  "Vehicle/fetchVehicleOutboundWorkflow",
  async (payload) => {
    const response = await getVehicleOutboundWorkflow(payload);
    return response;
  }
);

export const fetchVehicleOutbound = createAsyncThunk(
  "Vehicle/fetchVehicleOutbound",
  async (payload) => {
    const response = await getVehicleOutbound(payload);
    return response;
  }
);

export const fetchVehicleInfoupdate = createAsyncThunk(
  "Vehicle/fetchVehicle",
  async (payload) => {
    const response = await getVehicleInfoUpdate(payload);
    return response;
  }
);

export const fetchVehicleMaintenance = createAsyncThunk(
  "Vehicle/fetchVehicleMaintenance",
  async (payload) => {
    const response = await getVehicleMaintenace(payload);
    return response;
  }
);

export const fetchVehicleMovement = createAsyncThunk(
  "Vehicle/fetchVehicleMovement",
  async (payload) => {
    const response = await getVehicleMovement(payload);
    return response;
  }
);

export const fetchVehicleStocktake = createAsyncThunk(
  "Vehicle/fetchVehicleStocktake",
  async (payload) => {
    const response = await getVehicleStocktake(payload);
    return response;
  }
);

export const fetchVehiclePrint = createAsyncThunk(
  "Vehicle/fetchVehiclePrint",
  async (payload) => {
    const response = await getVehicleInboundWorkflow(payload);
    return response;
  }
);

export const fetchVehiclePrintNoloading = createAsyncThunk(
  "Vehicle/fetchVehiclePrintNoloading",
  async (payload) => {
    const response = await getVehicleInboundWorkflow(payload);
    return response;
  }
);

export const fetchListInspection = createAsyncThunk(
  "Vehicle/fetchListInspection",
  async (payload) => {
    const response = await geListInspection(payload);
    return response;
  }
);

export const addVehicle = createAsyncThunk(
  "Vehicle/addVehicle",
  async (payload) => {
    const response = await createVehicle(payload);
    return response;
  }
);

export const addVehicleUpload = createAsyncThunk(
  "Vehicle/addVehicleUpload",
  async (payload) => {
    const response = await createVehicleUpload(payload);
    return response;
  }
);

export const editVehicle = createAsyncThunk(
  "Vehicle/editVehicle",
  async (payload) => {
    const response = await updateVehicle(payload);
    return response;
  }
);

export const editVehicleTSA = createAsyncThunk(
  "Vehicle/editVehicleTSA",
  async (payload) => {
    const response = await updateVehicleTSA(payload);
    return response;
  }
);
export const editVehicleRCI = createAsyncThunk(
  "Vehicle/editVehicleRCI",
  async (payload) => {
    const response = await updateVehicleRCI(payload);
    return response;
  }
);
export const editVehicleStocktakeWorkFlow = createAsyncThunk(
  "Vehicle/editVehicleStocktakeWorkFlow",
  async (payload) => {
    const response = await updateVehicleStocktake(payload);
    return response;
  }
);

export const editVehiclePicking = createAsyncThunk(
  "Vehicle/editVehiclePicking",
  async (payload) => {
    const response = await updateVehiclePicking(payload);
    return response;
  }
);
export const editVehicleHandover = createAsyncThunk(
  "Vehicle/editVehicleHandover",
  async (payload) => {
    const response = await updateVehicleHandover(payload);
    return response;
  }
);
export const editVehicleBTS = createAsyncThunk(
  "Vehicle/editVehicleBTS",
  async (payload) => {
    const response = await updateVehicleBTS(payload);
    return response;
  }
);
export const editVehiclePDI = createAsyncThunk(
  "Vehicle/editVehiclePDI",
  async (payload) => {
    const response = await updateVehiclePDI(payload);
    return response;
  }
);
export const editVehicleMovementWorkFlow = createAsyncThunk(
  "Vehicle/editVehicleMovementWorkFlow",
  async (payload) => {
    const response = await updateVehicleMovementWorkflow(payload);
    return response;
  }
);
export const editVehicleMaintenance = createAsyncThunk(
  "Vehicle/editVehicleMaintenance",
  async (payload) => {
    const response = await updateVehicleMaintenance(payload);
    return response;
  }
);
export const editVehicleInspection = createAsyncThunk(
  "Vehicle/editVehicleInspection",
  async (payload) => {
    const response = await updateVehicleInspection(payload);
    return response;
  }
);
export const editVehicleRepdiin = createAsyncThunk(
  "Vehicle/editVehicleRepdiin",
  async (payload) => {
    const response = await updateVehicleRepdiin(payload);
    return response;
  }
);
export const editVehicleRepdiout = createAsyncThunk(
  "Vehicle/editVehicleRepdiout",
  async (payload) => {
    const response = await updateVehicleRepdiout(payload);
    return response;
  }
);
export const editVehicleInfoUpdate = createAsyncThunk(
  "Vehicle/editVehicleInfoUpdate",
  async (payload) => {
    const response = await updateVehicleInfoUpdate(payload);
    return response;
  }
);
export const editVehicleConfrim = createAsyncThunk(
  "Vehicle/editVehicleConfrim",
  async (payload) => {
    const response = await updateVehicleConfirm(payload);
    return response;
  }
);

export const editVehicleConfrimBTS = createAsyncThunk(
  "Vehicle/editVehicleConfrimBTS",
  async (payload) => {
    const response = await updateVehicleConfirmBTS(payload);
    return response;
  }
);

export const editVehicleConfirmMovement = createAsyncThunk(
  "Vehicle/editVehicleConfrim",
  async (payload) => {
    const response = await updateVehicleConfirmMovement(payload);
    return response;
  }
);

export const editVehicleCompleteMovement = createAsyncThunk(
  "Vehicle/editVehicleCompleteMovement",
  async (payload) => {
    const response = await updateVehicleCompleteMovement(payload);
    return response;
  }
);
export const editVehicleConfirmStocktake = createAsyncThunk(
  "Vehicle/editVehicleConfirmStocktake",
  async (payload) => {
    const response = await updateVehicleConfirmStocktake(payload);
    return response;
  }
);

export const editVehicleCompleteStocktake = createAsyncThunk(
  "Vehicle/editVehicleCompleteStocktake",
  async (payload) => {
    const response = await updateVehicleCompleteStocktake(payload);
    return response;
  }
);
export const editVehicleConfirmMaintenance = createAsyncThunk(
  "Vehicle/editVehicleConfirmMaintenance",
  async (payload) => {
    const response = await updateVehicleConfirmMaintenance(payload);
    return response;
  }
);

export const editVehicleCompleteMaintenance = createAsyncThunk(
  "Vehicle/editVehicleCompleteMaintenance",
  async (payload) => {
    const response = await updateVehicleCompleteMaintenance(payload);
    return response;
  }
);

export const editVehicleConfirmInfoUpdate = createAsyncThunk(
  "Vehicle/editVehicleConfirmInfoUpdate",
  async (payload) => {
    const response = await updateVehicleConfirmInfoUpdate(payload);
    return response;
  }
);

export const editVehicleCompleteInfoUpdate = createAsyncThunk(
  "Vehicle/editVehicleCompleteInfoUpdate",
  async (payload) => {
    const response = await updateVehicleCompleteInfoUpdate(payload);
    return response;
  }
);

export const editVehicleConfirmInspection = createAsyncThunk(
  "Vehicle/editVehicleConfirmInspection",
  async (payload) => {
    const response = await updateVehicleConfirmInspection(payload);
    return response;
  }
);

export const editVehicleConfirmREPDIIN = createAsyncThunk(
  "Vehicle/editVehicleConfirmREPDIIN",
  async (payload) => {
    const response = await updateVehicleConfirmREPDIIN(payload);
    return response;
  }
);

export const editVehicleCompleteREPDIIN = createAsyncThunk(
  "Vehicle/editVehicleCompleteREPDIIN",
  async (payload) => {
    const response = await updateVehicleCompleteREPDIIN(payload);
    return response;
  }
);

export const editVehicleConfirmREPDIOUT = createAsyncThunk(
  "Vehicle/editVehicleConfirmREPDIOUT",
  async (payload) => {
    const response = await updateVehicleConfirmREPDIOUT(payload);
    return response;
  }
);

export const editVehicleComplate = createAsyncThunk(
  "Vehicle/editVehicleComplate",
  async (payload) => {
    const response = await updateVehicleComplate(payload);
    return response;
  }
);

export const fetchIdVehicle = createAsyncThunk(
  "Vehicle/fetchIdVehicle",
  async (id) => {
    const response = await getIdVehicle(id);
    return response;
  }
);
export const fetchIdVehicleFind = createAsyncThunk(
  "Vehicle/fetchIdVehicleFind",
  async (id) => {
    const response = await getIdVehicleSeperator(id);
    return response;
  }
);

export const fetchIdVehicleFindInfoUpdate = createAsyncThunk(
  "Vehicle/fetchIdVehicleFindInfoUpdate",
  async (id) => {
    const response = await getIdVehicleSeperatorInfoUpdate(id);
    return response;
  }
);

export const fetchIdVehicleFindMaintenance = createAsyncThunk(
  "Vehicle/fetchIdVehicleFindMaintenance",
  async (id) => {
    const response = await getIdVehicleSeperatorMaintenance(id);
    return response;
  }
);

export const fetchMaintenanceActivityDetail = createAsyncThunk(
  "Vehicle/fetchMaintenanceActivityDetail",
  async (id) => {
    const response = await getMaintenanceActivityDetail(id);
    return response;
  }
)

export const fetchIdVehicleFindStocktake = createAsyncThunk(
  "Vehicle/fetchIdVehicleFindStocktake",
  async (id) => {
    const response = await getIdVehicleSeperatorStocktake(id);
    return response;
  }
);

export const removeVehicle = createAsyncThunk(
  "Vehicle/removeVehicle",
  async (payload) => {
    const response = await deleteVehicle(payload);
    return response;
  }
);
export const removeVehicleWorkFlow = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlow",
  async (payload) => {
    const response = await deleteVehicleWorkFlow(payload);
    return response;
  }
);
export const removeVehicleWorkFlowTSA = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowTSA",
  async (payload) => {
    const response = await deleteVehicleWorkFlowTSA(payload);
    return response;
  }
);
export const removeVehicleWorkFlowRCI = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowRCI",
  async (payload) => {
    const response = await deleteVehicleWorkFlowRCI(payload);
    return response;
  }
);
export const removeVehicleWorkFlowPDI = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowPDI",
  async (payload) => {
    const response = await deleteVehicleWorkFlowPDI(payload);
    return response;
  }
);
export const removeVehicleWorkFlowMovement = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowMovement",
  async (payload) => {
    const response = await deleteVehicleWorkFlowMovement(payload);
    return response;
  }
);
export const removeVehicleWorkFlowStocktake = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowStocktake",
  async (payload) => {
    const response = await deleteVehicleWorkFlowStocktake(payload);
    return response;
  }
);

export const removeVehicleWorkFlowPicking = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowPicking",
  async (payload) => {
    const response = await deleteVehicleWorkFlowPicking(payload);
    return response;
  }
);
export const removeVehicleWorkFlowHandover = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowHandover",
  async (payload) => {
    const response = await deleteVehicleWorkFlowHandover(payload);
    return response;
  }
);
export const removeVehicleWorkFlowBTS = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowBTS",
  async (payload) => {
    const response = await deleteVehicleWorkFlowBTS(payload);
    return response;
  }
);
export const removeVehicleWorkFlowMaintenance = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowMaintenance",
  async (payload) => {
    const response = await deleteVehicleWorkFlowMaintenance(payload);
    return response;
  }
);
export const removeVehicleWorkFlowInspection = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowInspection",
  async (payload) => {
    const response = await deleteVehicleWorkFlowInspection(payload);
    return response;
  }
);
export const removeVehicleWorkFlowRepdiin = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowRepdiin",
  async (payload) => {
    const response = await deleteVehicleWorkFlowRePdiin(payload);
    return response;
  }
);
export const removeVehicleWorkFlowRepdiout = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowRepdiout",
  async (payload) => {
    const response = await deleteVehicleWorkFlowRePdiout(payload);
    return response;
  }
);
export const removeVehicleWorkFlowInfoUpdate = createAsyncThunk(
  "Vehicle/removeVehicleWorkFlowInfoUpdate",
  async (payload) => {
    const response = await deleteVehicleWorkFlowInfoUpdate(payload);
    return response;
  }
);
// filter
export const fetchFilter = createAsyncThunk(
  "Vehicle/fetchFilter",
  async (payload) => {
    const response = await getFilter(payload);
    return response;
  }
);
export const addFilter = createAsyncThunk(
  "Vehicle/addFilter",
  async (payload) => {
    const response = await createFilter(payload);
    return response;
  }
);
export const removeFilter = createAsyncThunk(
  "Inbound/removeFilter",
  async (payload) => {
    const response = await deleteFilter(payload);
    return response;
  }
);

// Generate Excel
export const fetchGenerateExcel = createAsyncThunk(
  "Inbound/fetchGenerateExcel",
  async (payload) => {
    const response = await getGenerateExcelBlob(payload);
    return response;
  }
);

// get template
export const fetchFileTemplate = createAsyncThunk(
  "reporting/fetchFileTemplate",
  async ({ id, type }) => {
    const response = await getFile(id, type);
    return response;
  }
);
export const fetchFileTemplateBlob = createAsyncThunk(
  "reporting/fetchFileTemplateBlob",
  async ({ id, type }) => {
    const response = await getFileBlob(id, type);
    return response;
  }
);

export const fetchPrint = createAsyncThunk(
  "Vehicle/fetchPrint",
  async (payload) => {
    const response = await getPrint(payload);
    return response;
  }
);
export const addPrint = createAsyncThunk(
  "Vehicle/addPrint",
  async ({ vin, labeltpl_id, copies }) => {
    const response = await createPrint(vin, labeltpl_id, copies);
    return response;
  }
);

export const inboundSlice = createSlice({
  name: "inbound",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermisionRci: (state, action) => {
      state.permissionsRci = action.payload;
    },
    setPermisionPdiin: (state, action) => {
      state.permissionsPdiin = action.payload;
    },
    setPermisionPdiout: (state, action) => {
      state.permissionsPdiout = action.payload;
    },
    setPermisionStorage: (state, action) => {
      state.permissionsStorage = action.payload;
    },
    setPermisionList: (state, action) => {
      state.permissionsList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInbound.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdInbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdInbound.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addInbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(addInbound.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editInbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInbound.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editInboundSetstatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInboundSetstatus.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editInboundConfirm.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInboundConfirm.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editInboundAmend.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInboundAmend.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editInboundCancel.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInboundCancel.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeInbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeInbound.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addUploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchPrint.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrint.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addUploadFileRCI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUploadFileRCI.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addUploadFilePDIIN.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUploadFilePDIIN.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addUploadFilePDIOUT.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUploadFilePDIOUT.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addUploadFileTSA.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUploadFileTSA.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      // Vehicle
      .addCase(fetchVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVehicle = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      // Vehicle
      .addCase(fetchVehicleInboundWorkflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVehicleInboundWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVehicle = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchVehicleOutboundWorkflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVehicleOutboundWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVehicle = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchVehicleOutbound.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVehicleOutbound.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVehicle = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })

      .addCase(fetchVehicleMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVehicleMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVehicle = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchVehicleMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVehicleMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVehicle = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchVehicleStocktake.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVehicleStocktake.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVehicle = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })

      .addCase(fetchVehiclePrint.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVehiclePrint.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVehiclePrint = action.payload.data.data;
      })
      .addCase(fetchVehiclePrintNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchVehiclePrintNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataVehiclePrint = action.payload.data.data;
      })
      .addCase(fetchListInspection.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchListInspection.fulfilled, (state, action) => {
        state.loading = false;
        state.dataInspetion = action.payload.data.data;
      })
      .addCase(fetchIdVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdVehicle = action.payload.data.data;
      })
      .addCase(fetchIdVehicleFind.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdVehicleFind.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdVehicleFind = action.payload.data.data;
      })
      .addCase(fetchIdVehicleFindMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdVehicleFindMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdVehicleFind = action.payload.data.data;
      })
      .addCase(fetchMaintenanceActivityDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMaintenanceActivityDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdVehicleFind = action.payload.data.data;
      })
      .addCase(fetchIdVehicleFindInfoUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdVehicleFindInfoUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdVehicleFind = action.payload.data.data;
      })
      .addCase(fetchIdVehicleFindStocktake.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdVehicleFindStocktake.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdVehicleFind = action.payload.data.data;
      })
      .addCase(addVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(addVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addVehicleUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(addVehicleUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleTSA.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleTSA.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleRCI.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleRCI.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehiclePDI.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehiclePDI.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleMovementWorkFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleMovementWorkFlow.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleStocktakeWorkFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleStocktakeWorkFlow.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehiclePicking.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehiclePicking.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleConfrim.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleConfrim.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleConfrimBTS.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleConfrimBTS.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleComplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleComplate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeVehicleWorkFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeVehicleWorkFlow.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeVehicleWorkFlowTSA.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeVehicleWorkFlowTSA.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeVehicleWorkFlowRCI.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeVehicleWorkFlowRCI.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeVehicleWorkFlowPDI.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeVehicleWorkFlowPDI.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeVehicleWorkFlowMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeVehicleWorkFlowMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeVehicleWorkFlowStocktake.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeVehicleWorkFlowStocktake.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeVehicleWorkFlowPicking.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeVehicleWorkFlowPicking.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      // filter
      .addCase(fetchFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.dataFilter = action.payload.data.data;
      })
      .addCase(addFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(addFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchFileTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFileTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchFileTemplateBlob.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFileTemplateBlob.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(addPrint.pending, (state) => {
        state.loading = true;
      })
      .addCase(addPrint.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleCompleteMovement.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleCompleteMovement.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleCompleteStocktake.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleCompleteStocktake.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleCompleteMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleCompleteMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleConfirmMaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleConfirmMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleCompleteInfoUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleCompleteInfoUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleConfirmInfoUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleConfirmInfoUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleCompleteREPDIIN.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleCompleteREPDIIN.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editVehicleConfirmREPDIIN.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleConfirmREPDIIN.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleConfirmInspection.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleConfirmInspection.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editVehicleConfirmREPDIOUT.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVehicleConfirmREPDIOUT.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setPermisionList,
  setPermisionPdiin,
  setPermisionPdiout,
  setPermisionRci,
  setPermisionStorage,
} = inboundSlice.actions;

export const selectInbound = (state) => state.inbound.data;
export const selectInspection = (state) => state.inbound.dataInspetion;
export const selectIdInbound = (state) => state.inbound.dataId;
export const selectVehicle = (state) => state.inbound.dataVehicle;
export const selectVehiclePrint = (state) => state.inbound.dataVehiclePrint;
export const selectIdVehicle = (state) => state.inbound.dataIdVehicle;
export const selectIdVehicleFind = (state) => state.inbound.dataIdVehicleFind;
export const selectFilter = (state) => state.inbound.dataFilter;
export const selectLoading = (state) => state.inbound.loading;
export const selectError = (state) => state.inbound.error;
export const selectPageNo = (state) => state.inbound.pageNo;
export const selectPageSize = (state) => state.inbound.pageSize;
export const selectTotalRecord = (state) => state.inbound.totalRecord;
export const selectSelected = (state) => state.inbound.selected;
export const selectResult = (state) => state.inbound.result;

export const selectPermissionRci = (state) => state.inbound.permissionsRci;
export const selectPermissionPdiin = (state) => state.inbound.permissionsPdiin;
export const selectPermissionPdiout = (state) =>
  state.inbound.permissionsPdiout;
export const selectPermissionStorage = (state) =>
  state.inbound.permissionsStorage;
export const selectPermissionList = (state) => state.inbound.permissionsList;

export default inboundSlice.reducer;
